export const config = {
  //PROD
  apiEndpoint: "https://workshopapi.surreyschools.ca/Workshops",
  //DEV
  //apiEndpoint: "https://appd-as09:4546/Workshops",
};

export const msalConfig = {
  auth: {
    clientId: "36ffa3a7-120f-4590-bcb9-ab5a8b3eca12",
    authority:
      "https://login.microsoft.com/08b4e9cf-8113-420d-ba07-52f7d4df8acd", // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
    //DEV
    //redirectUri: "http://localhost:3000",
    //TEST
    //redirectUri: "https://appd-as09:4547/",
    //PROD
    redirectUri: "https://workshopreg.surreyschools.ca",
    scopes: [
      //"api://9eac46f8-a1c2-4f98-9505-6f1ea4f9d4c0/Workshops.Read.All",
      "User.Read",
      "User.Read.All",
      "User.ReadBasic.All",
      "People.Read",
      // "People.Read.All",
      // "Presence.Read.All",
      // "profile",
      // "offline_access",
      //"openid",
    ],
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  workshopApiScopes: [
    "api://9eac46f8-a1c2-4f98-9505-6f1ea4f9d4c0/Workshops.Read.All",
  ],
};
